export type LangCode = 'sr' | 'sr-cyrl' | 'en' | 'ru' | 'tr' | 'de';

export const LANG_CODES: LangCode[] = ['sr', 'sr-cyrl', 'en', 'ru', 'tr', 'de'];

export function isLangCode(value: string): value is LangCode {
  return (LANG_CODES as readonly string[]).includes(value);
}

/** Vrednost za `<html lang="...">` (BCP 47). */
export const DOCUMENT_HTML_LANG: Record<LangCode, string> = {
  sr: 'sr-Latn',
  'sr-cyrl': 'sr-Cyrl',
  en: 'en',
  ru: 'ru',
  tr: 'tr',
  de: 'de',
};

export const OG_LOCALE: Record<LangCode, string> = {
  sr: 'sr_RS',
  'sr-cyrl': 'sr_RS',
  en: 'en_GB',
  ru: 'ru_RU',
  tr: 'tr_TR',
  de: 'de_DE',
};
